import React, { useState } from 'react';
import { FINAL_RESULT_RULES } from '../utils/finalResultRule.js';

// The Final Result Rule info icon, shared by Add/Edit Pricing Template, the
// Pricing Template table header and the Pricing Template drawer so the wording
// stays identical in all three.
//
// Same dark-tooltip treatment as the "Pending" column info icon on Stock List
// (see StockInstancePage / Stockdrawer). The bubble is position:fixed against
// the icon's viewport rect, which is what lets it escape the th's
// overflow:hidden — neither the table wrapper nor the drawer sets a transform,
// so no ancestor becomes a containing block for it.
export default function FinalResultRuleTooltip() {
    const [tip, setTip] = useState({ show: false, top: 0, left: 0 });

    return (
        <>
            <div
                style={{ display: 'inline-flex', alignItems: 'center', cursor: 'default', marginLeft: 3 }}
                onMouseEnter={(e) => {
                    const r = e.currentTarget.getBoundingClientRect();
                    setTip({ show: true, top: r.top, left: r.left + r.width / 2 });
                }}
                onMouseLeave={() => setTip(t => ({ ...t, show: false }))}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                    <g clipPath="url(#final_result_rule_info_clip)">
                        <path fillRule="evenodd" clipRule="evenodd" d="M5 9.375C6.16032 9.375 7.27312 8.91406 8.09359 8.09359C8.91406 7.27312 9.375 6.16032 9.375 5C9.375 3.83968 8.91406 2.72688 8.09359 1.90641C7.27312 1.08594 6.16032 0.625 5 0.625C3.83968 0.625 2.72688 1.08594 1.90641 1.90641C1.08594 2.72688 0.625 3.83968 0.625 5C0.625 6.16032 1.08594 7.27312 1.90641 8.09359C2.72688 8.91406 3.83968 9.375 5 9.375ZM5 10C6.32608 10 7.59785 9.47322 8.53553 8.53553C9.47322 7.59785 10 6.32608 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 0 5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10Z" fill="#5E6E82" />
                        <path d="M5.58122 4.11719L4.14997 4.29656L4.09872 4.53406L4.37997 4.58594C4.56372 4.62969 4.59997 4.69594 4.55997 4.87906L4.09872 7.04656C3.97747 7.60719 4.16435 7.87094 4.60372 7.87094C4.94435 7.87094 5.33997 7.71344 5.51935 7.49719L5.57434 7.23719C5.44934 7.34719 5.26684 7.39094 5.1456 7.39094C4.97372 7.39094 4.91122 7.27031 4.9556 7.05781L5.58122 4.11719Z" fill="#5E6E82" />
                        <path d="M5 3.4375C5.34518 3.4375 5.625 3.15768 5.625 2.8125C5.625 2.46732 5.34518 2.1875 5 2.1875C4.65482 2.1875 4.375 2.46732 4.375 2.8125C4.375 3.15768 4.65482 3.4375 5 3.4375Z" fill="#5E6E82" />
                    </g>
                    <defs>
                        <clipPath id="final_result_rule_info_clip">
                            <rect width="10" height="10" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            </div>
            {tip.show && (
                <div style={{ position: 'fixed', top: tip.top, left: tip.left, transform: 'translate(-50%, calc(-100% - 8px))', background: '#495057', color: 'white', padding: '16px', borderRadius: '8px', zIndex: 9999, minWidth: '300px', whiteSpace: 'normal', pointerEvents: 'none', fontFamily: 'Montserrat', fontSize: '12px', fontWeight: 400, lineHeight: '1.5' }}>
                    {FINAL_RESULT_RULES.map((rule, idx) => (
                        <div key={rule.value} style={idx > 0 ? { marginTop: '8px' } : undefined}>
                            <strong>{rule.label}:</strong> {rule.description}
                        </div>
                    ))}
                    <div style={{ width: 0, height: 0, borderRight: '15px solid transparent', borderBottom: '15px solid transparent', borderTop: '15px solid #495057', position: 'absolute', borderLeft: '15px solid transparent', left: '50%', top: '98%', transform: 'translateX(-50%)' }} />
                </div>
            )}
        </>
    );
}
